import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { setGuestAccessFlag, clearGuestAccessFlag } from '@/components/GuestRoute';

const PASSWORD_ENV = import.meta.env.VITE_GUEST_PORTAL_PASSWORD;
const FALLBACK_PASSWORD = 'whipt-guest';

export default function GuestAccessPage() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const requiredPassword = PASSWORD_ENV || FALLBACK_PASSWORD;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password.trim() === requiredPassword) {
      setGuestAccessFlag();
      setError('');
      navigate('/guest/organizer');
    } else {
      clearGuestAccessFlag();
      setError('Incorrect password.');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#050309] via-[#0a0f1c] to-[#0c1026] flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white/5 border border-white/10 rounded-2xl shadow-2xl p-8 backdrop-blur">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-bold text-white">Guest Access</h1>
          <p className="text-slate-300 text-sm mt-2">Enter the shared password to join without creating an account.</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm text-slate-200 mb-2">Access Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-lg bg-black/30 border border-white/15 text-white px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-400"
              placeholder="Enter password"
              required
            />
          </div>
          {error && <p className="text-sm text-rose-400">{error}</p>}
          <button
            type="submit"
            className="w-full py-2.5 rounded-lg bg-purple-600 hover:bg-purple-500 text-white font-semibold transition-colors"
          >
            Continue as Guest
          </button>
        </form>
        <p className="text-xs text-slate-400 mt-6 text-center">
          Password is shared privately. If you do not know it, request it from the host.
        </p>
      </div>
    </div>
  );
}
